import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/var/www/layouts/account.vue").then(m => m.default || m)),
  checkout: defineAsyncComponent(() => import("/var/www/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/www/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/var/www/layouts/empty.vue").then(m => m.default || m))
}